import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { T } from '../traks';
import {dataPlaceholder, formatWithSeparators} from '../misc'
import Logo from './Logo';

const getLink = () => {
    return "#";  
}



//Component to display relevant info about the currently selected company
export const CompanyInfo = (props) => {
  const link = getLink();

  const formattedNumberOfShares = props.marketData ? formatWithSeparators(props.marketData.StockAmount) : '';
  const formattedMarketCap = props.marketData ? formatWithSeparators(props.marketData.MarketCap) : '';

  return (
    <div className="py-4 px-3 d-lg-flex">
      <Card className='ad_company_info_card ad_company_info_card_company'>
        <CardBody className='p-2'>
          <div className='d-flex ad_company_info_card_header'>
            <h1 className='ad_text_white'><T>Who is</T> {dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.LocalName : '')}</h1>
          </div>
          <p className='pb-3'>
          {dataPlaceholder(props.businessDescription)}
          </p>
          <p><strong><T>Website</T>: </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.WebAddress : '')}</p>
          <p><strong><T>Head office</T>: </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.HeadOffice : '')}</p>
        </CardBody>
      </Card>
      <Card className='ad_company_info_card ad_company_info_card_security my-3 my-lg-0 mx-lg-3'>
        <CardBody className='p-2'>
         <div className='d-flex ad_company_info_card_header'>
            <h1 className='ad_text_white'><T>The security</T></h1>
          </div>
          <div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Number of owners</T>: </strong>{dataPlaceholder(props.NumberOfShareHolders)}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong>Ticker: </strong>{dataPlaceholder(props.ticker)}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Number of Shares</T>: </strong>{dataPlaceholder(formattedNumberOfShares)}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Market capitalisation</T>: </strong>{dataPlaceholder(formattedMarketCap)}
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
      <Card className='ad_company_info_card ad_company_info_card_security'>
        <CardBody className='p-2'>
         <div className='d-flex ad_company_info_card_header'>
            <h1 className='ad_text_white'><T>Which Market</T></h1>
          </div>
          <div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Sector:</T> </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.SectorName : '')}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Industry:</T> </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.IndustryName : '')}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Country:</T> </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.Country : '')}
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/c/CompanyInfo.js